"use client";

export * from "./View";
export { default } from "./View";

export * from "./ViewSeo";
export { default as ViewSeo } from "./ViewSeo";

export * from "./BMView";
export { default as BMView } from "./BMView";
